import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";
import config from "../config";
import vuetify from "../locale/vuetify";
import en from "./en_US";
import vn from "./vn_VN";
Vue.use(VueI18n);

const messages: LocaleMessages = {
  en: {
    ...en,
    $vuetify: vuetify.en,
  },
  vi: {
    ...vn,
    $vuetify: vuetify.vi,
  },
};

/**
 * Available locales
 */
export const locales = [
  {
    title: "English",
    locale: "en",
    abbr: "US",
  },
  {
    title: "Tiếng Việt",
    locale: "vi",
    abbr: "VN",
  },
];

/**
 * VueI18n instance
 */
export const getLocale = () => {
  let locale = config.settings.locale;
  try {
    locale = JSON.parse(window.localStorage.getItem("vuex")).settings.locale;
  } catch (error) {}
  return locale;
};

const i18n = new VueI18n({
  warnHtmlInMessage: "off",
  // set locale options: en_US | zh_CN | ru_RU
  locale: getLocale(),
  // set locale messages
  messages,
  silentTranslationWarn: true,
});

/**
 * Set locale to new value at Vue and Vuex.
 *
 * @param {Boolean} newLocale themeDark new value
 */
export async function setLocale(locale) {
  if (i18n.locale !== locale) {
    // i18n.locale = locale || config.settings.locale;
  } else {
    console.warn(`[Locale] "${locale}" is current`);
  }
}

export default i18n;
